import { useRuntimeConfig, useState } from '#imports'

import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useIsE2ETestingEnvironment } from '@backmarket/nuxt-module-qa/useIsE2ETestingEnvironment'

import { useSignifyd } from './useSignifyd'

/**
 * Initialize Signifyd fraud detection script on a specific page.
 * The fingerprinting state is shared globally - once initialized on any page,
 * it won't re-initialize on subsequent page navigations.
 *
 * @param pageName - Identifier for the page (used for logging only)
 */
export function useSignifydOnPage(pageName: string) {
  const logger = useLogger()
  const config = useRuntimeConfig()
  const isEnabled = config.public.FF_AUTH_SIGNIFYD_ENABLED

  const hasStartedFingerprinting = useState(
    'signifyd-fingerprinting',
    () => false,
  )

  const isE2ETestingEnvironment = useIsE2ETestingEnvironment()

  if (!isEnabled || isE2ETestingEnvironment || hasStartedFingerprinting.value) {
    return
  }

  const { onLoaded } = useSignifyd()
  const loadStartTime = performance.now()

  onLoaded(() => {
    const loadTime = performance.now() - loadStartTime
    logger.info(`Signifyd script loaded on ${pageName}`, {
      owners: ['bot-squad-identity'],
      loadTimeMs: loadTime,
    })
    hasStartedFingerprinting.value = true
  })
}
